import React from 'react';
import { HeadingElement as HeadingType } from '../../types/element.types';

interface HeadingElementProps {
  element: HeadingType;
}

/**
 * Heading Element Renderer
 * Renders H1-H6 heading elements
 */
const HeadingElement: React.FC<HeadingElementProps> = ({ element }) => {
  const Tag = element.settings?.level || 'h2';
  
  return React.createElement(
    Tag,
    {
      className: 'heading-element',
      style: element.styles as React.CSSProperties,
    },
    element.content
  );
};

export default HeadingElement;

